export default __webpack_public_path__ + "static/media/logos.6382a55a.png";